import React from 'react';
import {Link} from 'react-router-dom';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

/**
 * 
 * @param {object} props
 * @param {object} props.list
 * @param {string} props.list.key
 * @param {string} props.list.value
 * @param {string} props.list.label
 * @param {string} props.list.icon
 * 
 * sub list with the same data structure as list
 * @param {array} props.list.content
 * @param {object} props.list.content[i]
 * @param {React component} props.list.content[i].icon
 * @param {string} props.list.content[i].key
 * @param {string} props.list.content[i].value
 * @param {string} props.list.content[i].label
 */
const CardButtonGroupWithLinkProperty = (props) => {
  // console.log(props);
  return(
    <div css={css`
      width: 100%;
      margin: 30px 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-around;
    `}>
      {
        props.list.map((item, index)=>{
          return(
            <div 
              key={index}
              css={css`
                width: 30%;
                padding: 20px;
                margin: 0 0 10px 0;
                border-radius: 5px;
                cursor: pointer;
                border: 2px solid transparent;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                &:hover {
                  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
                  transition: all 0.6s ease;
                }
              `}>
              {
                item.value.startsWith('/')
                ? <Link to={`${item.value}`}>
                  <div css={css`
                    display: flex;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    justify-content: space-around;
                    align-items: center;
                    
                    div {
                      padding: 10px;
                    }

                    &:hover {
                      div {
                        transform: translateY(3px);
                        transition: all 0.6s ease;
                      }
                    }
                  `}>
                    <div css={css`
                      font-size: 3.5rem;
                    `}>{item.icon}</div>
                    <div css={css`
                      font-size: 1.1rem;
                      font-weight: 600;
                      transform: translateY(10px);
                    `}>{item.label}</div>
                  </div>
                </Link>
              : <a href={item.value} target="_blank" rel="noopener noreferrer">
                <div css={css`
                  display: flex;
                  flex-direction: column;
                  flex-wrap: nowrap;
                  justify-content: space-around;
                  align-items: center;
                  
                  div {
                    padding: 10px;
                  }

                  &:hover {
                    div {
                      transform: translateY(3px);
                      transition: all 0.6s ease;
                    }
                  }
                `}>
                  <div css={css`
                    font-size: 3.5rem;
                  `}>{item.icon}</div>
                  <div css={css`
                    font-size: 1.1rem;
                    font-weight: 600;
                    transform: translateY(10px);
                  `}>{item.label}</div>
                </div>
              </a>
              }
              
            </div>
          )
        })
      }
    </div>
  )
}

export default CardButtonGroupWithLinkProperty;